import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_ONBOARDING_PURPOSE } from "../../redux/actions/types";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

const cardsData = [
  {
    id: "job",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/stepOne/step%201%20-1.svg",
    label: "I want A Job",
    customIcon: true,
  },
  {
    id: "promoted",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/stepOne/step%201%20-2.svg",
    label: "I want To Get Promoted",
    customIcon: false,
  },
  {
    id: "switch",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/stepOne/step%201%20-3.svg",
    label: "I want To Switch Careers",
    customIcon: false,
  },
  {
    id: "learn",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/stepOne/step%201%20-4.svg",
    label: "I want To Learn New Skills",
    customIcon: false,
  },
  {
    id: "build",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/stepOne/step%201%20-5.svg",
    label: "I Want To Build My Profile",
    customIcon: false,
  },
  {
    id: "unsure",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/stepOne/step%201%20-6.svg",
    label: "I'm Not Sure Yet",
    customIcon: false,
  },
];

const StepOne = ({setStep}) => {
  const purpose = useSelector((store) => store?.onBoarding?.purpose);
  const firstName = useSelector(store => store?.profileDetails?.first_name);
  const dispatch = useDispatch();

  

  const handleSetPurpose = (purpose) => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIRST_STEP_CARD_CLICKED);
    dispatch({type: SET_ONBOARDING_PURPOSE, payload: purpose});
    setTimeout(() => {
      setStep(2);
    }, 500);
  }

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIRST_STEP_LOADED);
  }, []);

  return (
    <div className="w-full inline-flex flex-col items-start justify-start gap-2 relative">
        <div className="text-[24px] font-semibold text-white text-left leading-[125%]">What Brings You Here Today, {firstName}?</div>
      <div className="w-full mt-8 inline-flex grid grid-cols-2 grid-rows-3 items-center gap-2 relative flex-[0_0_auto]">
        {cardsData?.map((card) => (
          <div
            key={card.id}
            className={`flex flex-col w-full h-full items-center justify-center px-3 pb-3 pt-7 relative cursor-pointer rounded-2xl overflow-hidden border transition-all ${
              purpose === card?.label
                ? "bg-[#406aff33] border-[#7fc241] shadow-[0px_0px_20px_#00000080]"
                : "bg-[#406aff1a] border-transparent"
            }`}
              onClick={() => handleSetPurpose(card?.label)}
          >
            <div className="absolute top-4 right-4">
                <div
                  className={`w-4 h-4 rounded-full border-2 cursor-pointer transition-all ${
                    purpose === card?.label
                      ? "border-[#7fc241] p-[2px]"
                      : "border-[#7fc241] bg-transparent"
                  }`}
                  onClick={() => handleSetPurpose(card?.label)}
                >
                  {purpose === card?.label && (
                    <div className="w-full h-full rounded-full bg-[#7fc241]"></div>
                  )}
                </div>
              </div>
            <div className="p-0 w-full relative">
              
              <div className="inline-flex w-full flex flex-col items-center gap-3 relative flex-[0_0_auto]">
                  <img
                    className="relative w-16 h-16"
                    alt="Group"
                    src={card.icon}
                    width={64}
                    height={64}
                  />
        

                <div className="relative w-fit [font-family:'Inter',Helvetica] text-white text-base text-center tracking-[0] leading-[22.4px]">
                
                    <span className="font-normal">{card.label}</span>
              
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      
    </div>
  );
}; 

export default StepOne;
